<template>
  <div class="py-2 mb-8 bg-sn-gray-100 xl:mb-16">
    <div class="container">
      <div class="grid w-full grid-cols-3">
        <div :aria-disabled="step !== 1">
          <div class="flex px-4 py-1 leading-none xl:items-center text-xxs xl:text-sm">
            <div class="flex-shrink-0 mr-2">
              <div v-if="step === 2">
                <img src="~images/brussels/icons/lh-icon-circle-checkmark.svg" class="w-5 h-5">
              </div>
              <div
                v-if="step === 1"
                class="flex items-center justify-center flex-shrink-0 w-4 h-4 font-bold leading-none text-white rounded-full xl:w-5 xl:h-5 text-xxs bg-sn-primary"
              >
                1
              </div>
            </div>
            <span class="pt-0.5 xl:pt-0 text-sn-primary" :class="[ step === 1 ? 'text-sn-primary' : '']">
              {{ $t('components.navigation.step1') }}
            </span>
          </div>
        </div>

        <div :aria-disabled="step !== 2">
          <div class="flex px-4 py-1 leading-none xl:items-center text-xxs xl:text-sm">
            <div
              class="flex items-center justify-center flex-shrink-0 w-4 h-4 mr-2 font-bold leading-none text-white rounded-full xl:w-5 xl:h-5 text-xxs"
              :class="[step === 1 ? 'bg-sn-gray-300' : 'bg-sn-primary']"
            >
              2
            </div>
            <span class="pt-0.5 xl:pt-0" :class="[step === 1 ? 'text-sn-gray-300' : 'text-sn-primary']">
              {{ $t('components.navigation.step2') }}
            </span>
          </div>
        </div>

        <div aria-disabled>
          <div class="flex px-4 py-1 leading-none xl:items-center text-xxs xl:text-sm">
            <div class="flex items-center justify-center flex-shrink-0 w-4 h-4 mr-2 font-bold leading-none text-white rounded-full xl:w-5 xl:h-5 text-xxs bg-sn-gray-300">
              3
            </div>
            <span class="pt-0.5 xl:pt-0 text-sn-gray-300">
              {{ $t('components.navigation.step3') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
}
</script>
